module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "cut-off-view"
  }, [_c('CutOff', {
    attrs: {
      "icon": "",
      "text": "load more"
    }
  }), _vm._v(" "), _c('CutOff', {
    attrs: {
      "line": "",
      "text": "load more"
    }
  }), _vm._v(" "), _c('CutOff')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-732335ee!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/cutOffView.vue
// module id = 263
// module chunks = 0